<template>
  <div>
    <el-dialog
      class="message-comment-locator"
      title="评论定位"
      :z-index="5000"
      :visible.sync="visible"
      width="850px"
      :close-on-click-modal="false"
      append-to-body
      @closed="handleClosed"
    >
      <template v-if="selected">
        <div class="message-context">
          <strong>{{ selected.businessTitle || '原业务记录' }}</strong>
          <span v-if="selected.businessNo"> {{ selected.businessNo }}</span>
          <p>{{ selected.senderName }}：{{ selected.content }}</p>
        </div>
        <approve-info
          v-if="!selected.sourceType || selected.sourceType === 'approval'"
          :key="selected.id"
          :target-id="selected.workOrderId"
          :focus-record-id="selected.recordId"
          :interaction-only="true"
          @loaded="onContextLoaded"
          @success="handleInteractionChanged"
        />
        <follow-context
          v-else-if="['follow', 'followReply'].includes(selected.sourceType)"
          :key="selected.id"
          :message="selected"
          @loaded="onFollowLoaded"
        />
      </template>
    </el-dialog>
    <work-log-detail-dialog
      :visible="logVisible"
      :log-id="logId"
      :focus-message="selected"
      @update:visible="handleLogVisible"
      @loaded="onLogLoaded"
      @refresh="handleInteractionChanged"
    />
  </div>
</template>

<script>
import ApproveInfo from '@/views/crm/components/approveInfo'
import FollowContext from '@/views/message-center/FollowContext'
import WorkLogDetailDialog from '@/views/crm/workLog/components/detailDialog'
import { getApprovalMessage, readApprovalMessage, approvalMessageEvents } from '@/api/crm/approvalMessage'

export default {
  name: 'MessageCommentLocator',
  components: { ApproveInfo, FollowContext, WorkLogDetailDialog },
  data: () => ({ visible: false, logVisible: false, logId: null, selected: null, requestSeq: 0 }),
  watch: {
    '$route.query.interactionMessageId': {
      immediate: true,
      handler(messageId) {
        if (messageId && this.$route.path !== '/message-center') this.openMessage(messageId)
        else this.closeLocal()
      }
    }
  },
  beforeDestroy() {
    this.requestSeq += 1
  },
  methods: {
    async openMessage(messageId) {
      const seq = ++this.requestSeq
      try {
        const response = await getApprovalMessage(messageId)
        if (seq !== this.requestSeq) return
        this.selected = response.data
        if ((this.selected.sourceType || '').startsWith('workLog')) {
          this.visible = false
          this.logId = this.selected.sourceId
          this.logVisible = true
        } else {
          this.logVisible = false
          this.visible = true
        }
      } catch (err) {
        if (seq !== this.requestSeq) return
        this.$message.error((err && err.message) || '消息已失效或无权查看')
        this.clearRouteMessage()
      }
    },
    closeLocal() {
      this.requestSeq += 1
      this.visible = false
      this.logVisible = false
      this.logId = null
      this.selected = null
    },
    handleClosed() {
      if (!this.logVisible) this.clearRouteMessage()
    },
    handleLogVisible(value) {
      this.logVisible = value
      if (!value) this.clearRouteMessage()
    },
    clearRouteMessage() {
      if (!this.$route.query.interactionMessageId) return
      const query = Object.assign({}, this.$route.query)
      delete query.interactionMessageId
      const result = this.$router.replace({ path: this.$route.path, query, hash: this.$route.hash })
      if (result && result.catch) result.catch(() => {})
    },
    onContextLoaded(records) {
      const message = this.selected
      if (message && (records || []).some(item => String(item.recordId) === String(message.recordId))) this.markRead(message)
    },
    onFollowLoaded(records) {
      const message = this.selected
      if (message && (message.sourceType === 'follow' || (records || []).some(item => String(item.id) === String(message.recordId)))) this.markRead(message)
    },
    onLogLoaded(detail) {
      const message = this.selected
      if (message && String(detail.id) === String(message.sourceId)) this.markRead(message)
    },
    async markRead(message) {
      if (!message || message.readTime || message._reading) return
      this.$set(message, '_reading', true)
      try {
        await readApprovalMessage(message.id)
        this.$set(message, 'readTime', new Date().toISOString())
        approvalMessageEvents.$emit('changed')
      } catch (err) {
        this.$message.error('已读状态保存失败，请重试')
      } finally {
        this.$delete(message, '_reading')
      }
    },
    handleInteractionChanged() {
      approvalMessageEvents.$emit('changed')
    }
  }
}
</script>

<style scoped>
.message-context { padding: 16px; margin-bottom: 12px; background: #f0f6ff; border-radius: 4px; }
.message-context p { margin-bottom: 0; white-space: pre-wrap; overflow-wrap: anywhere; }
</style>
